import { render, staticRenderFns } from "./ProjectSaisie.vue?vue&type=template&id=e8939620&scoped=true"
import script from "./ProjectSaisie.vue?vue&type=script&lang=js"
export * from "./ProjectSaisie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8939620",
  null
  
)

export default component.exports